<template>
  <Container>
    <PageHeader :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <h4 class="card-title">Customers</h4>
              <b-button v-b-modal.customer-modal @click="clearCustomer" variant="outline-primary"
                >Add Customer</b-button
              >
            </div>

            <b-modal size="lg" id="customer-modal" title="Enter Customer Details" title-class="font-18">
              <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <b-form id="customer-form" @submit.prevent="handleSubmit(onSubmit)">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group label="First name" label-for="first_name">
                        <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                          <b-form-input
                            id="first_name"
                            v-model="customer.first_name"
                            placeholder="Enter first name"
                          ></b-form-input>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group label="Last Name" label-for="last_name">
                        <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                          <b-form-input
                            id="last_name"
                            v-model="customer.last_name"
                            placeholder="Enter last Name"
                          ></b-form-input>

                          <small class="text-danger">{{ errors[0] }}</small>
                        </ValidationProvider>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-form-group label="Email" label-for="email">
                    <ValidationProvider vid="customer.email" rules="email|required" v-slot="{ errors }">
                      <b-form-input
                        id="email"
                        v-model="customer.email"
                        type="email"
                        placeholder="Enter email"
                      ></b-form-input>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>

                  <b-form-group label="Phone number" label-for="phone_number">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <b-form-input
                        id="phone_number"
                        v-model="customer.phone_number"
                        placeholder="Enter phone #"
                      ></b-form-input>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </b-form-group>
                </b-form>
              </ValidationObserver>

              <template v-slot:modal-footer>
                <b-button variant="secondary" @click="$bvModal.hide('customer-modal')">Close</b-button>
                <b-button form="customer-form" type="submit" variant="primary">Save</b-button>
              </template>
            </b-modal>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length mb-3">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="mx-1" v-model="perPage" size="sm" :options="pageOptions"></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                :items="customerItems"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(actions)="row">
                  <b-dropdown variant="default" dropleft>
                    <template v-slot:button-content>
                      <i class="fas fa-bars"></i>
                      <i class="bx bx-caret-down"></i>
                    </template>

                    <b-dropdown-item v-b-modal.customer-modal @click="toggleEdit(row.item.id)">
                      <i class="fa fa-pencil-alt"></i>
                      Edit
                    </b-dropdown-item>

                    <b-dropdown-item :to="{ path: 'customers/' + row.item.id }">
                      <i class="fa fa-info-circle"></i>
                      Details
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { getCustomers, createCustomer, updateCustomer } from "@/store/api";

export default {
  page: {
    title: "Customers",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
    PageHeader,
  },

  data() {
    return {
      customers: [],
      customer: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
      },
      update: false,
      customer_id: "",
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Customers",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "first_name" },
        { key: "last_name" },
        { key: "email" },
        { key: "phone_number" },
        { key: "actions", tdClass: "text-right" },
      ],
    };
  },

  created() {
    getCustomers().then((response) => (this.customers = response));
  },

  mounted() {
    this.totalRows = this.items.length;
  },

  computed: {
    rows() {
      return this.customerItems.length;
    },

    customerItems() {
      return this.customers.map((customer) => {
        return {
          id: customer.id,
          first_name: customer.attributes.first_name,
          last_name: customer.attributes.last_name,
          email: customer.attributes.email,
          phone_number: customer.attributes.phone_number,
        };
      });
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearCustomer() {
      this.update = false;
      this.customer_id = "";
      this.customer.first_name = "";
      this.customer.last_name = "";
      this.customer.email = "";
      this.customer.phone_number = "";
    },

    toggleEdit(id) {
      this.update = true;
      this.customer_id = id;
      let selectedCustomer = this.customers.find((customer) => customer.id == id);
      this.customer.first_name = selectedCustomer.attributes.first_name;
      this.customer.last_name = selectedCustomer.attributes.last_name;
      this.customer.email = selectedCustomer.attributes.email;
      this.customer.phone_number = selectedCustomer.attributes.phone_number;
    },

    onSubmit() {
      this.$bvModal.hide("customer-modal");
      if (this.update) {
        updateCustomer(this.customer, this.customer_id).then((response) => {
          let index = this.customers.findIndex((customer) => customer.id === this.customer_id);
          this.customers.splice(index, 1);
          this.customers.splice(index, 0, response);
        });
      } else {
        createCustomer(this.customer).then((response) => this.customers.push(response));
      }
    },
  },
};
</script>
